export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-3.85b8721e.svg";